<template>
  <div class="container">
    <router-view id="change-view"></router-view>
    <MemberLogin v-if="false" id="member-login"></MemberLogin>
  </div>
</template>

<script>
import MemberLogin from "@/views/member/member_login.vue";
export default {
  name: "memberMobile",
  components: {
    MemberLogin,
  },
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}
.container {
  display: flex;
  flex-wrap: nowrap;
  padding: 140px 70px 60px 70px;
  @include betweenPhoneTable {
    flex-wrap: wrap;
    padding: 140px 15px;
  }
}
#change-view {
  margin: 0 auto;
  @include tablePro {
    max-width: 656px;
  }
  @include phone {
    width: 100%;
  }
}
</style>
